import type { SocialStatAPIResponse } from "@/app/games/(details)/types";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";
import { DiscordLogo, SteamLogo, XLogo } from "../icons";
import { AppleLogo } from "../icons/AppleLogo";
import { GooglePlayLogo } from "../icons/GooglePlayLogo";
import { TelegramLogo } from "../icons/TelegramLogo";
import { TwitchLogo } from "../icons/TwitchLogo";
import { GlassButton } from "./GlassButton";

export const getPlatformButtons = (storeUrls: string[] | undefined) =>
  storeUrls?.map((url) => {
    if (url.includes("store.steampowered.com")) {
      return (
        <GlassButton
          target="_blank"
          rel="noopener noreferrer"
          label="Steam"
          control="steam-store"
          section={GamePageSection.TOP_BUTTONS}
          subLabel=""
          href={url}
          key={url}
          className="size-10 md:size-12"
          labelsClassName="hidden @3xl:block"
        >
          <SteamLogo className="md:scale-100 scale-90 size-5 text-white" />
        </GlassButton>
      );
    }
    if (url.includes("apps.apple.com")) {
      return (
        <GlassButton
          target="_blank"
          rel="noopener noreferrer"
          label="App Store"
          control="app-store"
          section={GamePageSection.TOP_BUTTONS}
          subLabel=""
          href={url}
          key={url}
          className="size-10 md:size-12"
          labelsClassName="hidden @3xl:block"
        >
          <AppleLogo className="md:scale-100 scale-90 size-5" />
        </GlassButton>
      );
    }
    if (url.includes("play.google.com")) {
      return (
        <GlassButton
          target="_blank"
          rel="noopener noreferrer"
          label="Play Store"
          control="play-store"
          section={GamePageSection.TOP_BUTTONS}
          subLabel=""
          href={url}
          key={url}
          className="size-10 md:size-12"
          labelsClassName="hidden @3xl:block"
        >
          <GooglePlayLogo className="md:scale-100 scale-90 size-5" />
        </GlassButton>
      );
    }
  });

const formatCount = (count: number | undefined) =>
  typeof count === "number" ? count.toLocaleString("en-US") : "";

export const getSocialButtons = (
  socials: SocialStatAPIResponse[] | undefined,
) =>
  socials?.map((social) => {
    switch (social.type) {
      case "x":
        return (
          <GlassButton
            key={social.type}
            label="Followers"
            control="x"
            section={GamePageSection.TOP_BUTTONS}
            subLabel={formatCount(social.count)}
            href={`https://x.com/intent/user?user_id=${social.handle}`}
            target="_blank"
            rel="noopener noreferrer"
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
          >
            <XLogo className="md:scale-100 scale-90 size-5" variant="solid" />
          </GlassButton>
        );
      case "discord":
        return (
          <GlassButton
            key={social.type}
            label="Members"
            control="discord"
            section={GamePageSection.TOP_BUTTONS}
            subLabel={formatCount(social.count)}
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
          >
            <DiscordLogo className="md:scale-100 scale-90 size-5" />
          </GlassButton>
        );
      case "telegram":
        return (
          <GlassButton
            key={social.type}
            label="Followers"
            control="telegram"
            section={GamePageSection.TOP_BUTTONS}
            subLabel={formatCount(social.count)}
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
          >
            <TelegramLogo className="md:scale-100 scale-90 size-5" />
          </GlassButton>
        );
      case "twitch":
        return (
          <GlassButton
            key={social.type}
            label="Followers"
            control="twitch"
            section={GamePageSection.TOP_BUTTONS}
            subLabel={formatCount(social.count)}
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
          >
            <TwitchLogo className="md:scale-100 scale-90 size-5" />
          </GlassButton>
        );
      default:
        return null;
    }
  });
